var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m12 1.586 6.707 6.707a1 1 0 0 1-1.414 1.414L13 5.414V17a1 1 0 1 1-2 0V5.414L6.707 9.707a1 1 0 1 1-1.414-1.414L12 1.586z","fill":"#fff","key":0}),React.createElement("path",{"d":"M3 14a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 1 1 2 0v4a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1z","fill":"#fff","key":1})]);
}

Upload.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Upload;

Upload.default = Upload;
